import type { TFunction } from 'i18next';
import { z } from 'zod';

export const applySchema = (t: TFunction) => z.object({
    age: z.number(t('Required_Field')).min(1, t('Required_Field')),
    city: z.string(t('Required_Field')).min(1, t('Required_Field')),
    timezone: z.string(t('Required_Field')).min(1, t('Required_Field')),
    irl_experience: z.boolean(t('Required_Field')),
    vatrus_apply: z.literal(true, t('Required_Field'))
});

export type FormFields = z.infer<ReturnType<typeof applySchema>>;
